import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

import TransparentBackgroundOverlay from './TransparentBackgroundOverlay';

const PopupOverlay = ({
    showOverlay,
    header,
    zIndex,
    hideCloseButton,
    onClose,
    overlay,
}) => {
    if (!showOverlay) return <div />;

    return (
        <TransparentBackgroundOverlay
            header={header}
            zIndex={zIndex}
            hideCloseButton={hideCloseButton}
            onClose={onClose}
        >
            <div>{overlay}</div>
        </TransparentBackgroundOverlay>
    );
};

PopupOverlay.propTypes = {
    showOverlay: PropTypes.bool,
    header: PropTypes.string,
    zIndex: PropTypes.number,
    hideCloseButton: PropTypes.bool,
    onClose: PropTypes.func,
    overlay: PropTypes.any,
};

const Popup = (props) => {
    const { overlay, header, usePortal, zIndex, onPopupOpen, hideCloseButton } =
        props;
    const [showOverlay, setShowOverlay] = useState(false);
    const modalRoot = document.querySelector('#icp-modal-root');

    const handlePopupOpen = () => {
        // Call the callback before opening the popup (if provided)
        if (onPopupOpen) {
            onPopupOpen();
        }
        setShowOverlay(true);
    };

    const handlePopupClose = () => {
        setShowOverlay(false);
    };

    return (
        <div>
            <div onClick={handlePopupOpen}>{props.children}</div>

            {usePortal &&
                ReactDOM.createPortal(
                    <PopupOverlay
                        showOverlay={showOverlay}
                        header={header}
                        zIndex={zIndex}
                        hideCloseButton={hideCloseButton}
                        onClose={handlePopupClose}
                        overlay={overlay}
                    />,
                    modalRoot
                )}

            {!usePortal && (
                <PopupOverlay
                    showOverlay={showOverlay}
                    header={header}
                    zIndex={zIndex}
                    hideCloseButton={hideCloseButton}
                    onClose={handlePopupClose}
                    overlay={overlay}
                />
            )}
        </div>
    );
};

Popup.propTypes = {
    overlay: PropTypes.any,
    header: PropTypes.string,
    usePortal: PropTypes.bool,
    children: PropTypes.any,
    zIndex: PropTypes.number,
    hideCloseButton: PropTypes.bool,
    onPopupOpen: PropTypes.func,
};

export default Popup;
